import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const { t } = useTranslation();

  return (
    <footer className="border-t border-[#E5E0D6] bg-[#FDFBF7]">
      <div className="px-6 md:px-12 py-8">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="caption text-muted-foreground">
            &copy; {currentYear} Decolonial Formations. {t('footer.copyright')}.
          </p>
          <nav className="flex items-center gap-6" style={{ direction: 'ltr' }}>
            <Link
              to="/privacy-policy"
              className="caption text-muted-foreground hover:text-[#1C1C1C] transition-colors"
            >
              {t('nav.privacy')}
            </Link>
            <Link
              to="/cookie-policy"
              className="caption text-muted-foreground hover:text-[#1C1C1C] transition-colors"
            >
              {t('nav.cookies')}
            </Link>
            <Link
              to="/terms"
              className="caption text-muted-foreground hover:text-[#1C1C1C] transition-colors"
            >
              {t('nav.terms')}
            </Link>
          </nav>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
